<template>
  <div>
    <div v-if="modelValue.length" class="d-flex flex-column gap-1 mb-2">
      <div v-for="(d, i) in modelValue" :key="(d.code || '') + d.libelle" class="diag d-flex align-items-center gap-2" :class="{ principal: d.principal }">
        <button type="button" class="btn btn-sm p-0 border-0" :disabled="lectureSeule" :title="d.principal ? 'Diagnostic principal' : 'Définir comme principal'" @click="principal(i)">
          <i :class="d.principal ? 'bi bi-star-fill text-warning' : 'bi bi-star text-muted'"></i>
        </button>
        <span class="flex-grow-1">{{ d.libelle }} <span v-if="d.code" class="badge bg-light text-secondary border ms-1">{{ d.code }}</span></span>
        <span v-if="d.principal" class="badge bg-primary-subtle text-primary">Principal</span>
        <button v-if="!lectureSeule" type="button" class="btn btn-sm btn-link text-danger p-0" title="Retirer" @click="retirer(i)"><i class="bi bi-x-lg"></i></button>
      </div>
    </div>
    <div v-else class="text-muted small mb-2">Aucun diagnostic retenu.</div>

    <div v-if="!lectureSeule" class="position-relative">
      <input v-model="q" type="search" class="form-control" placeholder="Rechercher (ex. paludisme, B54) ou saisir un diagnostic libre puis Entrée"
             @input="chercher" @keydown.enter.prevent="ajouterLibre(false)" @keydown.down.prevent="actif = Math.min(actif + 1, propositions.length - 1)" @keydown.up.prevent="actif = Math.max(actif - 1, 0)" @blur="fermerPlusTard">
      <div v-if="ouvert && (propositions.length || q.trim())" class="list-group position-absolute w-100 shadow-sm propositions">
        <button v-for="(p, i) in propositions" :key="p.code" type="button" class="list-group-item list-group-item-action py-1" :class="{ active: i === actif }" @mousedown.prevent="ajouter(p)">
          <span class="badge bg-light text-secondary border me-2">{{ p.code }}</span>{{ p.libelle }}
        </button>
        <button v-if="q.trim()" type="button" class="list-group-item list-group-item-action py-1 text-primary" @mousedown.prevent="ajouterLibre(true)">
          <i class="bi bi-plus-circle me-1"></i> Ajouter « {{ q.trim() }} » (sans code)
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'DiagnosticsCim10',
  props: { modelValue: { type: Array, default: () => [] }, lectureSeule: Boolean },
  emits: ['update:modelValue'],
  data() {
    return { q: '', propositions: [], ouvert: false, actif: 0, minuteur: null, recherche: null }
  },
  methods: {
    chercher() {
      clearTimeout(this.minuteur)
      this.ouvert = true
      const q = this.q
      this.recherche = new Promise(resolve => {
        this.minuteur = setTimeout(async () => {
          try {
            const res = await api.liste('cim10', { q })
            if (q === this.q) {
              this.propositions = res.data.data || []
              this.actif = 0
            }
          } catch {
            this.propositions = []
          }
          resolve()
        }, 200)
      })
    },
    emettre(liste) {
      if (liste.length && !liste.some(d => d.principal)) liste[0].principal = true
      this.$emit('update:modelValue', liste)
    },
    ajouter(p) {
      const liste = this.modelValue.map(d => ({ ...d }))
      if (!liste.some(d => (d.code && d.code === p.code) || d.libelle.toLowerCase() === p.libelle.toLowerCase())) {
        liste.push({ code: p.code || null, libelle: p.libelle, principal: liste.length === 0 })
      }
      this.q = ''
      this.recherche = null
      this.propositions = []
      this.ouvert = false
      this.emettre(liste)
    },
    async ajouterLibre(force = false) {
      if (!force) {
        // Entrée tapée avant la réponse de la recherche : on l'attend
        if (this.recherche) await this.recherche
        if (this.propositions[this.actif]) {
          this.ajouter(this.propositions[this.actif])
          return
        }
      }
      const t = this.q.trim()
      if (t) this.ajouter({ code: null, libelle: t })
    },
    retirer(i) {
      const liste = this.modelValue.filter((_, k) => k !== i).map(d => ({ ...d }))
      this.emettre(liste)
    },
    principal(i) {
      const liste = this.modelValue.map((d, k) => ({ ...d, principal: k === i }))
      liste.unshift(...liste.splice(i, 1))
      this.emettre(liste)
    },
    fermerPlusTard() {
      setTimeout(() => { this.ouvert = false }, 150)
    },
  },
}
</script>

<style scoped>
.diag { padding: 6px 10px; border: 1px solid #e3e8ef; border-radius: 8px; background: #fff; }
.diag.principal { border-color: #9ec5fe; background: #f4f8ff; }
.propositions { z-index: 20; max-height: 280px; overflow-y: auto; }
</style>
